import type {
  ThesaurusNodeDetailsCodeValue,
  ThesaurusNodeDetailsValue,
} from 'services/thesaurus/types';

export const isCodeValue = (
  value: ThesaurusNodeDetailsValue,
): value is ThesaurusNodeDetailsCodeValue => {
  const textValue = value as ThesaurusNodeDetailsCodeValue;
  return textValue.type === 'code';
};
